/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Orders<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Orders
   * @name CreateCreate
   * @request POST:/Orders/Create
   * @secure
   */
  createCreate = (
    data: {
      product: number;
      code?: string;
      quantity?: number;
      paymentMethod?: number;
      utmSource?: string;
      utmMedium?: string;
      utmCampaign?: string;
      utmContent?: string;
      utmTerm?: string;
      street?: string;
      city?: string;
      companyName?: string;
      companyIC?: string;
      companyDIC?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/Orders/Create`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Orders
   * @name CreatePublicCreate
   * @request POST:/Orders/CreatePublic
   */
  createPublicCreate = (
    data: {
      name: string;
      surname: string;
      email: string;
      password: string;
      product: number;
      code?: string;
      quantity?: number;
      paymentMethod?: number;
      utmSource?: string;
      utmMedium?: string;
      utmCampaign?: string;
      utmContent?: string;
      utmTerm?: string;
      street?: string;
      city?: string;
      companyName?: string;
      companyIC?: string;
      companyDIC?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<any, any>({
      path: `/Orders/CreatePublic`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Orders
   * @name GetUpcomingPaymentsList
   * @request GET:/Orders/GetUpcomingPayments
   * @secure
   */
  getUpcomingPaymentsList = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Orders/GetUpcomingPayments`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Orders
   * @name PendingBankTransferList
   * @request GET:/Orders/PendingBankTransfer
   * @secure
   */
  pendingBankTransferList = (params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Orders/PendingBankTransfer`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Orders
   * @name GetInstallmentDetail
   * @request GET:/Orders/GetInstallment/{installmentId}
   */
  getInstallmentDetail = (installmentId: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Orders/GetInstallment/${installmentId}`,
      method: "GET",
      ...params,
    });
  /**
   * No description
   *
   * @tags Orders
   * @name SwitchToCardCreate
   * @request POST:/Orders/SwitchToCard/{installmentId}
   */
  switchToCardCreate = (installmentId: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Orders/SwitchToCard/${installmentId}`,
      method: "POST",
      ...params,
    });
  /**
   * No description
   *
   * @tags Orders
   * @name SwitchToBankTransferCreate
   * @request POST:/Orders/SwitchToBankTransfer/{installmentId}
   */
  switchToBankTransferCreate = (installmentId: string, params: RequestParams = {}) =>
    this.request<any, any>({
      path: `/Orders/SwitchToBankTransfer/${installmentId}`,
      method: "POST",
      ...params,
    });
}
